import SubmitButton from "@/components/common/Button/SubmitButton";
import { Form, Input, Button } from "antd";
import { useState } from "react";
import { FaArrowRight } from "react-icons/fa6";

const RegisterStepPhone = ({ onSubmit, loading }) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const isTouched = form.isFieldsTouched(true);
    setIsFormValid(!hasErrors && isTouched);
  };

  return (
    <>
       
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        className="login-reg-form"
        onFieldsChange={handleFormChange}
      >
        <label className="label" htmlFor="phone">ফোন নাম্বার</label>
        <Form.Item
          name="phone"
          id="phone"
          rules={[
            { required: true, message: "ফোন নাম্বার দাও" },
            {
              pattern: /^0\d{10}$/,
              message: "সঠিক ১১ সংখ্যার ফোন নাম্বার দিন (০ দিয়ে শুরু)",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="ফোন নাম্বার"
            className="rounded"
            addonBefore="+88"
            maxLength={11}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>

        <SubmitButton
          text="এগিয়ে যান"
          loading={loading}
          disabled={!isFormValid}
        />
      </Form>
    </>
  );
};

export default RegisterStepPhone;
